import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '../store/actions';
import { getBaseClasses, getOrientation, isScreenOrientationSupported } from '../helpers';

export const useDeviceClassNames = () => {
    const dispatch = useDispatch();
    const [baseClasses, setBaseClasses] = useState(getBaseClasses());

    const updateDeviceOrientation = useCallback(
        () => {
            dispatch(actions.updateDeviceAction(getOrientation()));
            setBaseClasses(getBaseClasses());
        },
        [dispatch]
    );

    useEffect(() => {
        if (isScreenOrientationSupported) {
            screen.orientation.addEventListener('change', updateDeviceOrientation);

            return () => {
                screen.orientation.removeEventListener('change', updateDeviceOrientation);
            };
        }

        window.addEventListener('orientationchange', updateDeviceOrientation);

        return () => {
            window.removeEventListener('orientationchange', updateDeviceOrientation);
        };
    }, [updateDeviceOrientation]);

    return baseClasses;
};
